import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
  SET_PERSONNEL_LOADING,
  GET_PERSONNEL_LIST,
  SET_PERSONNEL_COUNT,
  GET_PERSON_TAB_DATA,
  ADD_PERSONNEL_DELETION,
  CLEAR_PERSONNEL_DELETIONS,
  GET_PERSON_FILES,
  GET_PERSONNEL_ROLES_LIST,
  GET_PERSONNEL_ALL_ROLES_LIST,
  GET_PERSONNEL_ATTESTATIONS_LIST,
  GET_PERSONNEL_LESSONS_LIST,
  GET_PERSON_DROPDOWN,
} from "../types";

// Маппинг внутренних названий табов на API
export const TAB_MAPPING = {
  main: 'main',
  additional: 'additional',
  education: 'education',
  qualification: 'professional_development',
  award: 'awards',
  punish: 'penalties',
  experience: 'total_work_experience',
  lesson: 'courses',
  event: 'events',
  role: 'roles',
  documents: 'files',
  attestation: 'certification',
  family: 'family',
  vacation: 'vacation',
  socialBenefits: 'privileges',
  militaryRecord: 'military',
  languages: 'foreign_languages',
  issuedDocuments: 'issued_documents',
  umbInfo: 'equipment'
};

// ==================== СПИСОК СОТРУДНИКОВ ====================

export const getPersonnelList = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const { data } = await api.get(`/personnel_structure?status=${params || ''}&limit=200&offset=0`);
    dispatch({ type: GET_PERSONNEL_LIST, payload: data.items || data });
    dispatch({ type: SET_PERSONNEL_COUNT, payload: data.count || 0 });
  } catch (ERR) {
    console.error('getPersonnelList error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

// ==================== ПОЛУЧЕНИЕ ДАННЫХ СОТРУДНИКА ====================

export const getPersonTable = (tab, mid) => async (dispatch) => {
  let result = { success: false, errorCode: null };
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const apiTab = TAB_MAPPING[tab] || tab;
    const { data } = await api.get(`/personnel_structure/${mid}?tab=${apiTab}`);
    // Ответ: { tab: "...", data: ... }
    dispatch({ type: GET_PERSON_TAB_DATA, payload: { tab, data: data.data || data } });
    result.success = true;
  } catch (ERR) {
    console.error('getPersonTable error:', ERR);
    result.errorCode = ERR?.response?.status;
    if (result.errorCode === 500) {
      createNotification('warning', 'Ошибка сервера при загрузке данных сотрудника');
    }
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
  return result;
};

// ==================== СОЗДАНИЕ СОТРУДНИКА ====================

export const createPersonnelInfo = (formData) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });

    // formData уже структурирован по вкладкам (main, additional и т.д.)
    // Фильтруем пустые объекты/массивы
    const payload = {};

    Object.keys(formData).forEach(key => {
      const value = formData[key];
      if (value && typeof value === 'object') {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            payload[key] = value;
          }
        } else {
          if (Object.keys(value).length > 0) {
            payload[key] = value;
          }
        }
      }
    });

    const { data } = await api.post('/personnel_structure', payload);
    success = true;
    createNotification('success', 'Сотрудник успешно создан');
    await dispatch(getPersonnelList(formData?.main?.workstatus));
  } catch (ERR) {
    console.error('createPersonnelInfo error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка создания сотрудника');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// ==================== ОБНОВЛЕНИЕ СОТРУДНИКА ====================

export const updatePersonnelInfo = (mid, tabData, deletions = {}) => async (dispatch) => {
  console.log('tabData::: ', tabData);
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });

    const payload = { ...tabData };

    // Добавляем поля удаления del_*
    Object.keys(deletions).forEach(apiTab => {
      if (deletions[apiTab] && deletions[apiTab].length > 0) {
        payload[`del_${apiTab}`] = deletions[apiTab];
      }
    });

    await api.put(`/personnel_structure/${mid}`, payload);
    success = true;
    createNotification('success', 'Данные успешно сохранены');
  } catch (ERR) {
    console.error('updatePersonnelInfo error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка сохранения');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// ==================== УДАЛЕНИЕ СОТРУДНИКА ====================

export const deletePersonnel = (mid) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await api.delete(`/personnel_structure/${mid}`);
    success = true;
    createNotification('success', 'Сотрудник удален');
  } catch (ERR) {
    console.error('deletePersonnel error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка удаления');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// ==================== ТРЕКИНГ УДАЛЕНИЙ ====================

export const addDeletion = (apiTab, itemId) => ({
  type: ADD_PERSONNEL_DELETION,
  payload: { apiTab, itemId }
});

export const clearDeletions = () => ({
  type: CLEAR_PERSONNEL_DELETIONS
});

// Локальное обновление данных таба (для сохранения при переключении вкладок)
export const updateLocalTabData = (tab, data) => ({
  type: GET_PERSON_TAB_DATA,
  payload: { tab, data }
});

// ==================== ПРЕДМЕТЫ (COURSES) ====================

export const getPersonCourses = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const { data } = await api.get(`/personnel_structure/${mid}/courses`);
    dispatch({ type: GET_PERSONNEL_LESSONS_LIST, payload: data });
  } catch (ERR) {
    console.error('getPersonCourses error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

export const addPersonCourses = (mid, cids, tab) => async (dispatch) => {
  console.log('tab::: ', tab);
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await api.post(`/personnel_structure/${mid}/courses`, { cids });
    success = true;
    await dispatch(getPersonTable(tab, mid));
  } catch (ERR) {
    console.error('addPersonCourses error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка добавления предметов');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

export const deletePersonCourses = (mid, cids) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await api.delete(`/personnel_structure/${mid}/courses`, { data: { cids } });
    success = true;
    await dispatch(getPersonCourses(mid));
  } catch (ERR) {
    console.error('deletePersonCourses error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка удаления предметов');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// Legacy aliases for backward compatibility
export const getPersonLesson = getPersonCourses;
export const deleteLesson = ({ mid, pid }) => deletePersonCourses(mid, [pid]);

// ==================== РОЛИ ====================

export const getPermissionGroups = () => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const { data } = await api.get('/permission_groups');
    dispatch({ type: GET_PERSONNEL_ALL_ROLES_LIST, payload: data });
  } catch (ERR) {
    console.error('getPermissionGroups error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

export const getRolesforPersonnel = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const { data } = await api.get(`/personnel_structure/${mid}?tab=roles`);
    dispatch({ type: GET_PERSONNEL_ROLES_LIST, payload: data.data || data });
  } catch (ERR) {
    console.error('getRolesforPersonnel error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

export const assignRole = (groupId, mid) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await api.post(`/permission_groups/${groupId}/users/${mid}`);
    success = true;
    await dispatch(getRolesforPersonnel(mid));
  } catch (ERR) {
    console.error('assignRole error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка назначения роли');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

export const removeRole = (groupId, mid) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await api.delete(`/permission_groups/${groupId}/users/${mid}`);
    success = true;
    await dispatch(getRolesforPersonnel(mid));
  } catch (ERR) {
    console.error('removeRole error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка удаления роли');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// Legacy aliases
export const createRolesforPersonnel = assignRole;
export const updateRolesforPersonnel = assignRole;

// ==================== ФАЙЛЫ ====================

export const getPersonFiles = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const { data } = await api.get(`/personnel_structure/${mid}?tab=files`);
    const files = data.data || data;
    dispatch({ type: GET_PERSON_FILES, payload: files });
    return files;
  } catch (ERR) {
    console.error('getPersonFiles error:', ERR);
    return [];
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

export const downloadPersonFile = (mid, fileName) => async () => {
  try {
    const response = await api.get(`/personnel_structure/${mid}/files/${encodeURIComponent(fileName)}`, {
      responseType: 'blob'
    });
    // Создаем ссылку для скачивания
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (ERR) {
    console.error('downloadPersonFile error:', ERR);
    createNotification('error', 'Ошибка скачивания файла');
  }
};

export const uploadPersonFile = (mid, file) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const formData = new FormData();
    formData.append('file', file);
    await api.post(`/personnel_structure/${mid}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    success = true;
    createNotification('success', 'Файл загружен');
    await dispatch(getPersonFiles(mid));
  } catch (ERR) {
    console.error('uploadPersonFile error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка загрузки файла');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

export const deletePersonFile = (mid, fileName) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await api.delete(`/personnel_structure/${mid}/files/${encodeURIComponent(fileName)}`);
    success = true;
    createNotification('success', 'Файл удален');
    await dispatch(getPersonFiles(mid));
  } catch (ERR) {
    console.error('deletePersonFile error:', ERR);
    createNotification('error', ERR?.response?.data?.message || 'Ошибка удаления файла');
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// ==================== АТТЕСТАЦИЯ ====================

export const getAttestationforPersonnel = (mid) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    const { data } = await api.get(`/personnel_structure/${mid}?tab=certification`);
    dispatch({ type: GET_PERSONNEL_ATTESTATIONS_LIST, payload: data.data || data });
  } catch (ERR) {
    console.error('getAttestationforPersonnel error:', ERR);
    dispatch({ type: GET_PERSONNEL_ATTESTATIONS_LIST, payload: [] });
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

export const createAttestationforPersonnel = (data) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await dispatch(updatePersonnelInfo(data.mid, {
      certification: [data]
    }));
    success = true;
    await dispatch(getAttestationforPersonnel(data.mid));
  } catch (ERR) {
    console.error('createAttestationforPersonnel error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

export const updateAttestationforPersonnel = (data) => async (dispatch) => {
  let success = false;
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    await dispatch(updatePersonnelInfo(data.mid, {
      certification: [data]
    }));
    success = true;
    await dispatch(getAttestationforPersonnel(data.mid));
  } catch (ERR) {
    console.error('updateAttestationforPersonnel error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
    return success;
  }
};

// ==================== МЕРОПРИЯТИЯ ====================

export const getPersonEvents = (mid, schoolYear) => async (dispatch) => {
  try {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: true });
    let url = `/personnel_structure/${mid}?tab=events`;
    if (schoolYear) {
      url += `&school_year=${schoolYear}`;
    }
    const { data } = await api.get(url);
    dispatch({ type: GET_PERSON_TAB_DATA, payload: { tab: 'event', data: data.data || data } });
  } catch (ERR) {
    console.error('getPersonEvents error:', ERR);
  } finally {
    dispatch({ type: SET_PERSONNEL_LOADING, payload: false });
  }
};

// ==================== ВЫПАДАШКИ ДЛЯ ВКЛАДОК ====================

export const getSuggestions = (field) => async (dispatch) => {
  try {
    const { data } = await api.get(`/personnel_structure/suggestions?field=${field}`);
    dispatch({ type: GET_PERSON_DROPDOWN, payload: data });
    return data.values || data;
  } catch (ERR) {
    console.error('getSuggestions error:', ERR);
    return [];
  }
};
